import React, { FC, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { useSelector } from 'react-redux';
import { CircularProgress, Link } from '@mui/material';

import { ParamsProps } from 'src/app/common/components/ParamsProvider';
import { useDetail } from './detail.hook';
import ApplicationItem from '../Download/components/ApplicationItem';
import LoginDialog from 'src/app/common/components/LoginDialog';
import { RedirectType } from 'src/app/common/types';
import { useStyles } from '../Download/DownloadPage';
import LanguageSwitch from 'src/app/common/components/layout/components/container/components/header/language-switch';
import { useTranslation } from 'src/app/common/hooks/translation.hook';
import { RootState } from 'src/redux/store';
import { TokenInfo } from 'src/app/modules/Auth/types/auth-types';
import { appDetailPageName } from '../ApplicationRoutes';
import { toAbsoluteUrl } from 'src/app/common/utils';

type PageProps = ParamsProps &
  RouteComponentProps & {
  /* otherProp: string */
};

export const DetailPage: React.FC<PageProps> = () => {
  const { classes } = useStyles();

  const { t } = useTranslation();
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const user = useSelector<RootState, TokenInfo | undefined>((state) => state.auth.user);
  // custom-hook
  const { loading, data, error, onLogout } = useDetail();

  return (
    <>
      <div className={classes.root}>
        <div className={classes.header}>
          <Link href={"https://www.prudential.co.id/"}>
            <img
              style={{ width: 160 }}
              src={toAbsoluteUrl("/media/download-page/prudential_id.jpeg")}
              alt={"Prudential Logo"}
            />
          </Link>

          <div className={classes.rowContainer}>
            {user ? (
              <div className={classes.loginBtn}>{user.username}</div>
            ) : (
              <div className={classes.loginBtn} onClick={() => setOpenDialog(true)}>
                {t('common.login')}
              </div>
            )}
            {user && (
              <div className={`${classes.logoutBtn} tw-mr-2`} onClick={onLogout}>
                {t('common.logout')}
              </div>
            )}
            <LanguageSwitch />
          </div>
        </div>
        <LoginDialog
          open={openDialog}
          redirect={RedirectType.APPLICATION_DOWNLOAD}
          onClose={() => setOpenDialog(false)}
        />

        <div className={classes.descriptionSection}>
          <div className={classes.descriptionTitle}>
            <span className="tw-font-extrabold">{t('downloadPage.title.download')}</span> {t('downloadPage.title')}
          </div>
        </div>
        <div className="tw-mb-6" />

        <div className="tw-px-1 tw-bg-white tw-h-full tw-relative tw-flex-grow tw-overflow-y-auto tw-rounded-[16px]">
          {loading ? (
            <div className={classes.applicationInnerContainer}>
              <CircularProgress color="secondary" />
            </div>
          ) : data && data.length > 0 ? (
            <ApplicationItem
              key={`application-item`}
              applicationItem={data[0]}
              onOpenLoginDialog={() => {}}
              pageName={appDetailPageName}
            />
          ) : error ? (
            <div className={classes.applicationInnerContainer}>{t('common.no_record')}</div>
          ) : (
            <div className={classes.applicationInnerContainer}>{t('downloadPage.noApp')}</div>
          )}
        </div>
      </div>
    </>
  );
};
